import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Btn, CustomModal, InputText } from '../../../../components'
import { errorHandler } from '../../../../services/util/error.service'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'
import EstoqueHttp from '../../../../services/api/https/estoque/Estoque.http'

const LOAD_MESSAGE = {
  NONE: 'NONE',
  CREATE: 'Criando estoque',
  UPDATE: 'Atualizando estoque',
  SUCCESS: 'Estoque salvo com sucesso',
}

const INITIAL_STATE = {
  estoque: {
    id: null,
    name: '',
    posicoes: [],
  },
  nova_posicao: {
    id: 0,
    endereco: '',
    sequencia: '',
    capacidade: 0.0,
  },
  savedEstoque: {},
  activeTab: 0,
  loadingMessage: LOAD_MESSAGE.NONE,
  errorMessage: null,
}

const MANDATORY_FIELDS = {
  NAME: 'O nome do estoque deve ser preenchido',
}

const ModalCadastroEstoque = ({ data, show, onModalSave, onModalClose, dispatch, tpId }) => {
  const [state, setState] = useState({ ...INITIAL_STATE })

  useEffect(() => {
    if (show) {
      setState(prevState => ({ ...prevState, estoque: { ...data }, activeTab: 0 }))
    }
  }, [show])

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break

      case LOAD_MESSAGE.CREATE:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        saveEstoque(state.estoque, tpId)
        break

      case LOAD_MESSAGE.UPDATE:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        updateEstoque(state.estoque, tpId)
        break

      case LOAD_MESSAGE.SUCCESS:
        dispatch(hideLoadingBox())
        dispatch(showMessageBox(state.loadingMessage, null))
        onModalSave(state.savedEstoque)
        break

      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      setState(prevState => ({
        ...prevState,
        loadingMessage: LOAD_MESSAGE.NONE,
        errorMessage: null,
      }))
    }
  }, [state.errorMessage])

  // Events
  const onBtnSalvarClicked = estoque => {
    if (validateFieldsBeforeSubmit(estoque)) {
      if (typeof estoque.id !== 'undefined')
        setState(prevState => ({ ...prevState, loadingMessage: LOAD_MESSAGE.UPDATE }))
      else setState(prevState => ({ ...prevState, loadingMessage: LOAD_MESSAGE.CREATE }))
    }
  }

  const onFormChange = (name, value) => {
    setState(prevState => {
      prevState.estoque[name] = value
      return { ...prevState }
    })
  }

  // Helper
  const saveEstoque = (estoque, tpId) => {
    EstoqueHttp.saveEstoque(tpId, {
      name: estoque.name.trimStart().trimEnd(),
      tp_id: tpId,
    })
      .then(estoque =>
        setState(prevState => ({
          ...prevState,
          loadingMessage: LOAD_MESSAGE.SUCCESS,
          savedEstoque: estoque,
        })),
      )
      .catch(err =>
        setState(prevState => ({
          ...prevState,
          errorMessage: errorHandler(err),
          loadingMessage: LOAD_MESSAGE.NONE,
        })),
      )
  }

  const updateEstoque = (estoque, tpId) => {
    EstoqueHttp.saveEstoque(tpId, {
      id: estoque.id,
      name: estoque.name.trimStart().trimEnd(),
      tp_id: tpId,
    })
      .then(estoque =>
        setState(prevState => ({
          ...prevState,
          loadingMessage: LOAD_MESSAGE.SUCCESS,
          savedEstoque: estoque,
        })),
      )
      .catch(err =>
        setState(prevState => ({
          ...prevState,
          errorMessage: errorHandler(err),
          loadingMessage: LOAD_MESSAGE.NONE,
        })),
      )
  }

  const validateFieldsBeforeSubmit = fields => {
    const mandatoryFields = {
      name: fields.name,
    }
    const names = Object.keys(mandatoryFields)
    const isValid = names.every(field => {
      if (mandatoryFields[field].trim() !== '') {
        return true
      }
      setState(prevState => ({ ...prevState, errorMessage: MANDATORY_FIELDS[field.toUpperCase()] }))
      return false
    })
    return isValid
  }

  // Render
  return (
    <CustomModal
      header={state.estoque.id ? 'Editar Estoque' : 'Novo Estoque'}
      isVisible={show}
      onClose={onModalClose}
      width={450}
    >
      <form className="p-grid" onSubmit={e => e.preventDefault()}>
        <div className="p-col-12">
          <span style={{ color: '#14B0BF', fontSize: '0.8rem' }}>(*) Campo Obrigatório</span>
        </div>
        <div className="p-col-12">
          <InputText
            label="Nome do Estoque* :"
            marginTop={10}
            value={state.estoque.name}
            onChange={value => onFormChange('name', value)}
          />
        </div>
        <div className="p-col-12" style={{ paddingTop: 32, textAlign: 'end' }}>
          <Btn onClick={() => onBtnSalvarClicked(state.estoque)}>Salvar</Btn>
        </div>
      </form>
    </CustomModal>
  )
}

export default connect()(ModalCadastroEstoque)
